module.exports = __webpack_public_path__ + "static/media/HEADER.7031f219.png";